/*
 *
 * AmlPopupConfirm
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 23-Jul-2025
*/

import React from 'react'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantFlowCard from '@nexidigital/merchantflowcard'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import PortalButton from '@nexidigital/portalbutton'
import { ArrowDownload } from '@nexidigital/iconlibrary'
import './AmlPopupConfirm.scss'

const AmlPopupConfirm = (props) => (
  <MerchantModal
    topBarTitle=' '
    title={formattedMessage.controlAndSave}
    onClose={() => props.actions.doHidePopup()}
    primaryAction={() => props.actions.doSubmitAml({ data: { ...props.amlInfo, hasDocumentsToSave: props.files.length > 0 }, files: props.files })}
    primaryButtonLoading={props.isLoading}
    primaryButtonLabel={formattedMessage.save}
    secondaryButtonLabel={formattedMessage.cancel}
    secondaryAction={() => props.actions.doHidePopup()}
  >
    <MerchantFlowCard
      title={formattedMessage.verifyInfo}
      subtitle={formattedMessage.subtitle}
    >
      <div className='amlPopupConfirmButton'>
        <PortalButton
          secondary
          label={formattedMessage.download}
          icon={<ArrowDownload size='24' type='fill' />}
          loading={props.isLoadingDownload}
          onClick={() => props.actions.doDownloadSurvey({ ...props.amlInfo, hasDocumentsToSave: props.files.length > 0 })}
        />
      </div>
    </MerchantFlowCard>
  </MerchantModal>

)

AmlPopupConfirm.propTypes = {
  // Add here some propTypes
  actions: PropTypes.object.isRequired,
  amlInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  isLoadingDownload: PropTypes.bool,
  files: PropTypes.array
}

AmlPopupConfirm.defaultProps = {
  // Add here some default propTypes values
  actions: {},
  amlInfo: {},
  isLoading: false,
  isLoadingDownload: false,
  files: []
}

export default AmlPopupConfirm
